import React from 'react';
import { InviteWrapper } from './components/Invite';

export const Invite = ({ setInvitionModalVisible }) => (
  <InviteWrapper setInvitionModalVisible={setInvitionModalVisible} />
);
